import { REQUEST_TIMEOUT_SEC } from './config.js';

import { async } from 'regenerator-runtime';

const timeout = sec =>
  new Promise((_, reject) =>
    setTimeout(
      () => reject(Error(`Request timed out. Please try again later...`)),
      sec * 1000
    )
  );

export const AJAX = async (url, uploadData = undefined) => {
  try {
    const req = uploadData
      ? fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(uploadData),
        })
      : fetch(url);

    const res = await Promise.race([req, timeout(REQUEST_TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw Error(data.message);

    return data;
  } catch (err) {
    if (err.message === 'Failed to fetch')
      err.message = `Unable to reach the server. Please check your internet connection...`;
    throw err;
  }
};

/* export const getJSON = async url => {
  try {
    const res = await Promise.race([fetch(url), timeout(REQUEST_TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw Error(data.message);

    return data;
  } catch (err) {
    if (err.message === 'Failed to fetch')
      err.message = `Unable to reach the server. Please check your internet connection...`;
    throw err;
  }
};

export const sendJSON = async (url, uploadData) => {
  try {
    const postRequest = fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(uploadData),
    });

    const res = await Promise.race([postRequest, timeout(REQUEST_TIMEOUT_SEC)]);
    const data = await res.json();

    if (!res.ok) throw Error(data.message);

    return data;
  } catch (err) {
    throw err;
  }
}; */
